import { useMutation } from 'react-query';

import { EindomfinansAPI } from '../api';

export const useCheckRequestKeyMutation = () => {
    return useMutation(EindomfinansAPI.checkRequestKey);
};
